<app-page-stepper
    [verticalSteps]="false"
    [isMaterial]="false"
    (submit)='onRegister()'
    (tryNext)='registerCanContinue()'
    [submitVisible]="true">
    <app-stepper [canContinue]="canContinue">
        <ng-template #title>
            {{ "auth.registerStepOne" | translate }}
        </ng-template>
        <ng-template
            #content
            let-step="step">

            <form
                [formGroup]="registerFormStepOne">

                <app-input
                    [formControl]="registerFormStepOne.controls.username"
                    [showErrors]="showValidations"
                    [placeholder]="'auth.registerUsernameLabel' | translate"
                    label="{{ 'auth.registerUsernameLabel' | translate }}">
                </app-input>

                <app-input
                    [formControl]="registerFormStepOne.controls.firstName"
                    [showErrors]="showValidations"
                    [placeholder]="'auth.firstNameLabel' | translate"
                    label="{{ 'auth.firstNameLabel' | translate }}">
                </app-input>

                <app-input
                    [formControl]="registerFormStepOne.controls.lastName"
                    [showErrors]="showValidations"
                    [placeholder]="'auth.lastNameLabel' | translate"
                    label="{{ 'auth.lastNameLabel' | translate }}">
                </app-input>

                <app-textarea
                    [formControl]="registerFormStepOne.controls.registerReason"
                    [showErrors]="showValidations"
                    [placeholder]="'auth.registerReasonLabel' | translate"
                    label="{{ 'auth.registerReasonLabel' | translate }}">
                </app-textarea>
            </form>
        </ng-template>
    </app-stepper>
    <app-stepper>
        <ng-template #title>
            {{ "auth.registerStepTwo" | translate }}
        </ng-template>
        <ng-template #content>
            <form
                [formGroup]='registerFormStepTwo'>
                <app-input
                    type="email"
                    [formControl]="registerFormStepTwo.controls.email"
                    [showErrors]="showValidations"
                    [placeholder]="'auth.registerEmailLabel' | translate"
                    label="{{ 'auth.registerEmailLabel' | translate }}">>
                </app-input>

                <app-input
                    type="password"
                    [formControl]="registerFormStepTwo.controls.password"
                    [showErrors]="showValidations"
                    [placeholder]="'auth.passwordLabel' | translate"
                    label="{{ 'auth.passwordLabel' | translate }}">
                </app-input>

                <app-input
                    type="password"
                    [formControl]="registerFormStepTwo.controls.passwordConfirmation"
                    [showErrors]="showValidations"
                    [placeholder]="'auth.confirmPasswordLabel' | translate"
                    label="{{ 'auth.confirmPasswordLabel' | translate }}">
                </app-input>
                <app-alert *ngIf="passwordMatch" type="error"
                           message="{{ 'auth.passwordNotMatching' | translate }}"></app-alert>
            </form>
        </ng-template>
    </app-stepper>
</app-page-stepper>
<a routerLink="/auth" class="register-redirect">{{ 'auth.buttons.back' | translate }}</a>

<app-confirmation-modal
    (scanEvent)="onConfirmRegister($event)"
    title="{{'auth.message.registerPopupTitle' | translate}}"
    message="{{'auth.message.registerPopupMessage' | translate}}">
</app-confirmation-modal>
